import type { InjectionKey, Ref } from 'vue'

/**
 * Threaded from `DSSidebar` down to every row (`DSSidebarItem`,
 * `DSSidebarGroup`, `DSSidebarCollapseToggle`) so callers only pass
 * `collapsed` once, at the root, instead of on every row.
 */
export const SIDEBAR_COLLAPSED: InjectionKey<Ref<boolean>> = Symbol('sidebar-collapsed')
